import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/serviceWorker";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// iter184 (Feb 20, 2026): re-enabled SW registration after the
// kill-switch drain. Behind `REACT_APP_PWA_ENABLED` — when "true",
// the v3 PWA SW (network-first navigations, cache-first hashed
// /static/, network-only /api/*) registers; when "false", the
// kill-switch sw.js still gets registered to clean up any v1/v2
// remnants on returning browsers.
//
// The function is a no-op on localhost (CRA dev server) per the
// `lib/serviceWorker.js` guard.
registerServiceWorker();
